import { render, staticRenderFns } from "./TramosRutasForm.vue?vue&type=template&id=4db5b218"
import script from "./TramosRutasForm.vue?vue&type=script&lang=js"
export * from "./TramosRutasForm.vue?vue&type=script&lang=js"
import style0 from "./TramosRutasForm.vue?vue&type=style&index=0&id=4db5b218&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports